import { Dispatch } from 'redux';
import {
	SET_SELECTED_DOCUMENT_TABLE,
	SET_SELECTED_SUBDOCUMENT_TABLE
} from '../types/types';
export const setDocumentTable =
	(selectedDocumentTable: string, selectedSubDocumentTable: string) =>
	(dispatch: Dispatch) => {
		dispatch({
			type: SET_SELECTED_DOCUMENT_TABLE,
			selectedDocumentTable: selectedDocumentTable,
			selectedSubDocumentTable: selectedSubDocumentTable
		});
	};

export const setSubDocumentTable =
	(selectedSubDocumentTable: string) => (dispatch: Dispatch) => {
		dispatch({
			type: SET_SELECTED_SUBDOCUMENT_TABLE,
			selectedSubDocumentTable: selectedSubDocumentTable
		});
	};
